import React from 'react';
import NumberFormat from 'react-number-format';
import { determineFundName, determineFundTicker, determineRegistrationGroupingDisplayName } from '../TransferUtils';
import './ConfirmationTableCells.scss';

const totalReducer = (prev, curr) => prev + curr;

const FromAccounts = ({agreementGroup}) => <>
    <div className='confirmationTableCellTitle'>
        {determineRegistrationGroupingDisplayName(agreementGroup)}
    </div>
    {agreementGroup.agreements.filter(agreement => agreement.isTransfer).map(agreement =>
        <div className='confirmationTableCellAccount blocked_data'>
            <div className='confirmationTableCellAccountName'>
                {determineFundName(agreement, agreementGroup.productTypeId)} {determineFundTicker(agreement, agreementGroup.productTypeId)}
            </div>
            <div className='confirmationTableCellAccountDetail'>
                {agreement.agreementNumber}{agreement.checkSum ? `-${agreement.checkSum}` : null} • {agreementGroup.owners.join(', ')}
                {agreementGroup.deceasedOwner && agreementGroup.deceasedOwner.length ? `, ${agreementGroup.deceasedOwner} (DCD)` : ''}
                {agreementGroup.powerOfAttorney && agreementGroup.powerOfAttorney.length ? `, ${agreementGroup.powerOfAttorney} (Agent)` : ''}
            </div>
        </div>
    )}
</>;


const ToAccount = ({agreementGroup}) => <>
    <div className='confirmationTableCellTitle'>
        {determineRegistrationGroupingDisplayName(agreementGroup)}
    </div>
    <div className='confirmationTableCellAccount blocked_data'>
        <div className='confirmationTableCellAccountName'>
            Retirement Advisory Service
        </div>
        <div className='confirmationTableCellAccountDetail'>
            {agreementGroup.existingAgreement.agreementNumber}{agreementGroup.existingAgreement.checkSum ? `-${agreementGroup.existingAgreement.checkSum}` : null} •
            {agreementGroup.owners.join(', ')}{agreementGroup.deceasedOwner && agreementGroup.deceasedOwner.length ? `, ${agreementGroup.deceasedOwner} (DCD)` : ''}
            {agreementGroup.powerOfAttorney && agreementGroup.powerOfAttorney.length ? `, ${agreementGroup.powerOfAttorney} (Agent)` : ''}
        </div>
    </div>
</>;

const Totals = ({agreementGroup}) => <>
    <div className='confirmationTableCellTitle'>TOTAL</div>
    <div className='confirmationTableCellAccountName blocked_data'>
        <NumberFormat value={agreementGroup.agreements.filter(agreement => agreement.isTransfer).map(agreement => agreement.holdings.map(holding => holding.amount)
            .reduce(totalReducer)).reduce(totalReducer).toFixed(2)} displayType='text' thousandSeparator prefix='$' />
    </div>
</>;

export { FromAccounts, ToAccount, Totals };
